import React from 'react';
import { Button, ButtonPropsTheme } from '../../Button/Button';
import { RenderActions } from './ConfirmationModal';

interface RenderActionsProps {
  primaryButtonLabel?: string;
  primaryButtonTheme?: ButtonPropsTheme;
  primaryButtonOnClick: () => void;
  secondaryButtonOnClick?: () => void;
}

export function createTwoButtonsRenderActions(props: RenderActionsProps): RenderActions {
  const {
    primaryButtonTheme = 'contained-apply',
    primaryButtonLabel = 'Save',
    primaryButtonOnClick,
    secondaryButtonOnClick
  } = props;
  return function ModalAction(onClose) {
    return (
      <>
        <Button
          theme={primaryButtonTheme}
          onClick={() => {
            primaryButtonOnClick();
            onClose();
          }}
        >
          {primaryButtonLabel}
        </Button>
        <Button
          theme="outlined-discard"
          onClick={() => {
            secondaryButtonOnClick?.();
            onClose();
          }}
        >
          Cancel
        </Button>
      </>
    );
  };
}
